import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';

// Componente para una tarjeta de anuncio
const AnnouncementCard = ({ icon, title, text, style = {} }) => (
  <Card border='light' style={style}>
    <Card.Body style={{textAlign:'center'}}>
      <Card.Text><i className={`bi ${icon}`} style={{fontSize:'80px', color: style.color || 'green'}}></i></Card.Text>
      <Card.Title style={{fontSize:'25px'}}>{title}</Card.Title>
      <Card.Text style={{fontSize:'20px'}}>{text}</Card.Text>
    </Card.Body>
  </Card>
);

// Datos para las tarjetas de anuncios
const announcements = [
  {
    icon: "bi-people-fill",
    title: "Presupuesto participativo",
    text: "La municipalidad de Trenque Lauquen y el Colectivo Trenque Lauquen por Más Participación pusieron en marcha el Presupuesto Participativo"
  },
  {
    icon: "bi-lightbulb",
    title: "¿Qué es el presupuesto participativo?",
    text: "Es una iniciativa que busca darle la oportunidad al ciudadano/a de aportar ideas que mejoren y beneficien a su comunidad y que puedan transformar su barrio o localidad."
  },
  {
    icon: "bi-person-fill-add",
    title: "Presupuesto Participativo Joven",
    text: "Para jóvenes del distrito entre los 12 y 20 años de edad para aportar ideas y proyectos en una nueva edición del Presupuesto Participativo Joven que impulsa la municipalidad de Trenque Lauquen."
  }
];

// Datos para la sección naranja
const orangeSectionData = [
  {
    icon: "bi-person-check",
    title: "¿Quiénes pueden participar?",
    text: "Cualquier ciudadano puede participar para decidir el destino de un porcentaje del presupuesto municipal"
  },
  {
    icon: "bi-envelope-paper",
    title: "¿Cuándo se vota?",
    text: "La votación se realiza del lunes 11 al viernes 15 de noviembre de manera online y presencial"
  },
  {
    icon: "bi-bank",
    title: "¿Quién realiza los proyectos?",
    text: "Una vez aprobados y votados democráticamente por los vecinos el municipio se encarga de su ejecución"
  }
];

const AnunciosHome = () => {
  return (
    <>
      <Container style={{marginTop:'30px', display:'none'}}>
        <Row style={{paddingTop:'50px', paddingBottom:'50px'}}>
          <Col>
            <AnnouncementCard 
              icon="bi-file-earmark-check-fill"
              title="Estamos evaluando los proyectos"
              text="En principio el 26 de agosto está previsto realizar una feria de proyectos. Y entre el 4 y 10 de septiembre se hará la votación."
              style={{fontSize:'50px'}}
            />
          </Col>
        </Row>            
      </Container>
      
      <Container style={{marginTop:'30px'}}>
        <Row xs={1} md={3}>
          {announcements.map((announcement, index) => (
            <Col key={index}>
              <AnnouncementCard {...announcement} />
            </Col>
          ))}
        </Row>            
      </Container>
      <div style={{backgroundColor:'#ec6247', marginTop:'50px', color:'#f1f1f1', paddingTop:'30px', paddingBottom:'50px'}}>
        <Container>
          <Row xs={1} md={3}>
            {orangeSectionData.map((data, index) => (
              <Col key={index}>
                <AnnouncementCard {...data} style={{background:'none', border:'0', color:'#f1f1f1'}} />
              </Col>
            ))}
          </Row>            
        </Container>
      </div>
    </>
  );
};

export default AnunciosHome;